
import { Vue, Component } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';

@Component
export default class LookShopDrawer extends Vue {
  visible = false;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  data: any = [];

  columns = [
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: '200px',
      scopedSlots: { customRender: 'shop_name' },
    },
    {
      title: 'poi',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: '200px',
    },
    {
      title: '城市',
      dataIndex: 'city_name',
      key: 'city_name',
      align: 'center',
      width: '200px',
    },
  ];

  title = '查看店铺';

  async init(val: any, month: string) {
    const params = {
      month,
      spu_id: val.spu_id,
      user_id: val.user_id,
    };
    const res = await this.workbenchesService.getAdActivityList(params);
    if (res) {
      this.visible = true;
      this.data = res;
    }
  }

  goToShopDetail(id: string) {
    const routeUrl = this.$router.resolve({
      name: 'main.shop.detail',
      params: {
        id: `${id}`,
      },
    });
    window.open(routeUrl.href, '_blank');
  }

  onClose() {
    this.visible = false;
  }
}
